import { render, staticRenderFns } from "./addNewRules.vue?vue&type=template&id=5013b07c&scoped=true&"
import script from "./addNewRules.vue?vue&type=script&lang=ts&"
export * from "./addNewRules.vue?vue&type=script&lang=ts&"
import style0 from "./addNewRules.vue?vue&type=style&index=0&id=5013b07c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5013b07c",
  null
  
)

export default component.exports